import classNames from 'classnames';
import type { FC } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

export type ReloadButtonProps = {
  autoReloadEnabled: boolean;
  isReloading: boolean;
  onReload: () => Promise<void>;
};

export const ReloadButton: FC<ReloadButtonProps> = ({
  autoReloadEnabled,
  isReloading,
  onReload,
}) => {
  async function handleReloadClick() {
    if (isReloading) return;
    try {
      await onReload();
    } catch (err) {
      console.error('Failed to reload event info:', err);
    }
  }

  if (!autoReloadEnabled) return null;

  return (
    <div
      className={classNames('side-bar-toolbar-button', { 'disabled': isReloading })}
      title={t('Reload')}
      {...onClickGenerator(() => handleReloadClick())}
    >
      <i
        className={classNames('fas', {
          'fa-spinner fa-spin': isReloading,
          'fa-sync-alt': !isReloading,
        })}
      />
    </div>
  );
};
